<!-- popup.component.html -->
<div class="backdrop" *ngIf="isVisible" (click)="closePopup()"></div>

<div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': isVisible}">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <!-- Your popup content here -->
                <div class="col-sm-12">
                    <div class="row">
                        <div style="font-weight: 600;font-size: 32px;color: #2E2E2E;padding: 30px 18px 14px 17px;">
                            Hunch is best enjoyed on the <span style="color: #BA2257;">app</span>
                        </div>
                    </div>
                    <div class="row">
                        <div style="font-weight: 300;font-size: 16px;color: #191919;padding: 30px 18px 14px 17px;">
                            1M+ real friendships await you. Download Hunch to make them happen!
                        </div>
                    </div>
                    <div class="row content-align-center justify-content-sm-between" style="margin-bottom: 30px;">
                        <div class="">


                            <a href="{{appTrackingUrl}}?source=pop-up" target="_blank">
                                <img class="downloadButtons" src="./assets/play-store.svg" alt="Play Store">
                            </a>
                            <a href="{{appTrackingUrl}}" target="_blank">
                                <img class="downloadButtons" src="./assets/apple-store.svg" alt="App Store">
                            </a>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>